var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { Elevation } from '../../theme/elevation';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import OptionElement from './OptionElement';
import { ThemeFamilies } from '../../theme/families';
import { BodyOneTypography } from '../Typography/bodyOne';
var OptionList = function (_a) {
    var staticSize = _a.staticSize, className = _a.className, name = _a.name, options = _a.options, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, withCheckbox = _a.withCheckbox, isMulti = _a.isMulti, _d = _a.themeFamily, themeFamily = _d === void 0 ? ThemeFamilies.PRIMARY : _d, listTitle = _a.listTitle;
    var _e = useState(value), listValue = _e[0], setListValue = _e[1];
    var handleClick = function (optionValue) {
        var newListValue;
        if (isMulti && typeof listValue !== 'string') {
            if (listValue === null || listValue === void 0 ? void 0 : listValue.includes(optionValue)) {
                newListValue = listValue === null || listValue === void 0 ? void 0 : listValue.filter(function (val) { return val !== optionValue; });
            }
            else {
                newListValue = listValue === null || listValue === void 0 ? void 0 : listValue.concat(optionValue);
            }
        }
        else {
            newListValue = listValue === optionValue ? null : optionValue;
        }
        setListValue(newListValue);
        if (onChange) {
            onChange(newListValue);
        }
    };
    return (_jsxs(OptionListWrapper, __assign({ staticSize: staticSize, className: className, "data-testid": name, themeFamily: themeFamily }, { children: [listTitle && _jsx(OptionListTitle, { children: listTitle }, void 0),
            options === null || options === void 0 ? void 0 : options.map(function (option) { return (_jsx(OptionElement, { className: name + "-option", staticSize: staticSize, value: option.value, onClick: (option === null || option === void 0 ? void 0 : option.onClick) || handleClick, withCheckbox: withCheckbox, isSelected: isMulti ? listValue === null || listValue === void 0 ? void 0 : listValue.includes(option.value) : listValue === option.value, themeFamily: option === null || option === void 0 ? void 0 : option.themeFamily, label: option === null || option === void 0 ? void 0 : option.label, hide: option === null || option === void 0 ? void 0 : option.hide, name: option === null || option === void 0 ? void 0 : option.name, disabled: option === null || option === void 0 ? void 0 : option.disabled }, option.value)); })] }), void 0));
};
export default OptionList;
var OptionListWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: ", ";\n  border-radius: 12px;\n  overflow-x: auto;\n\n  ", "\n\n  ", "\n\n  & > :not(:last-child) {\n    margin-bottom: 4px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: ", ";\n  border-radius: 12px;\n  overflow-x: auto;\n\n  ",
    "\n\n  ", "\n\n  & > :not(:last-child) {\n    margin-bottom: 4px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.elevation[Elevation.DEPTH4];
}, function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    var _b = theme.families.optionList[themeFamily], main = _b.main, text = _b.text;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      color: ", ";\n    "], ["\n      background: ", ";\n      color: ", ";\n    "])), main, text);
}, getThemeBreakpoints('optionList'));
var OptionListTitle = styled(BodyOneTypography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 8px 12px;\n  font-size: inherit;\n"], ["\n  padding: 8px 12px;\n  font-size: inherit;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
